const culture = 'NLD';

const API_URL_BASE = `/api/lookup-transaction/${culture}`;
const HEADERS = {
	'Content-Type': 'application/x-www-form-urlencoded',
};

const handleFetch = (url, fetchOptions = {}, returnJson = true) => fetch(url, fetchOptions)
	.then((res) => {
		if (res.ok) {
			return returnJson ? res.json() : true;
		}

		throw Error('Something went wrong wile fetching');
	});

const post = body => handleFetch(`${API_URL_BASE}`, { method: 'POST', body, headers: HEADERS });

export {
	post,
};
